import {Component, OnInit, ElementRef, Output, EventEmitter, Input} from '@angular/core';
import {DefaultPackage, Package, PackageName, Rule} from '../services/capd.model';
import { PackageService } from '../services/package.service';
import {document} from "ngx-bootstrap/utils";

declare var $: any;

@Component({
  selector: 'package',
  templateUrl: './package.component.html'
})

/**
 * Component that manages packages.
 */
export class PackageComponent implements OnInit {
  selectedPackage: Package;
  selectedRules: Rule[];
  relational: PackageName[];
  changeListToggle = false;
  changeTrayToggle = false;
  showAdd = false;

  @Input() ruleDetail: Rule = {
    _id: '0000',
    triggerName: 'Placeholder',
    action: {
        actionType: 'Message',
        messageTitle: '',
        messageText: '',
        messagePriority: 'Normal'
      }
    };
  canEdit;

  @Output() listChange: EventEmitter<any> = new EventEmitter();
  existingPackages: string[];
  newPak: DefaultPackage = { _id: '', name: '', version: '1.0.0', state: 'Unpublished'};
  nameError = false;

  rule: any;

  constructor(
    private _service: PackageService,
    private _el: ElementRef
  ) { }

  /**
   * On the initialization of this component, get the packages, get the names of the packages, and create
   * relational objects.
   *
   * @async
   * @func ngOnInit
   */
  ngOnInit() {
    // Figure out whether or not the user has package editing permissions
    this.canEdit = this.hasPackageManagement;

    this.doUpdate();

  }

  /**
   * The bulk of the services work.  Gets the packages and groups them by versions.
   *
   * @async
   * @func doUpdate
   * @param {any} newPack - if the update is called by a new package being created,
   *                        pass that here so that package can be selected automatically.
   */
  doUpdate(newPack?) {
    this._service.getPackages().then((packages: Package[]) => {
      if (!!newPack) {
        this.selectedPackage = packages.filter(pack => newPack.version === pack.version && newPack.name === pack.name)[0];
        // wait 1 second for dom to render, and then autoscroll to the new package
        setTimeout(() => {
          let elementString: string = "pkg-" + newPack.name
          let scrollTo = document.getElementById(elementString)
          scrollTo.scrollIntoView()
        }, 1000)
      }
      this._service.getNames().then((names: string[]) => {
        this.existingPackages = names
        const rel = new Array(0);
        names.forEach(name => {
          const subPackages = packages.filter(version => name === version.name);
          subPackages.forEach(pack => {
            if (!pack.numberOfCustomers) { pack.numberOfCustomers = 0; }
            if (!pack.numberOfRules) { pack.numberOfRules = 0; }
          });

          // Sorts the packages from newest (biggest numbers) to oldest (smallest numbers)
          rel.push(new PackageName(name, subPackages.sort((a, b) => {
            const verA = a.version.split('.');
            const verB = b.version.split('.');
            let i = 0;
            while (i < verA.length || i < verB.length) {
                if (i < verA.length && i < verB.length) {
                    if (+verA[i] - +verB[i] !== 0)
                    { return (+verA[i] - +verB[i]) * -1; }
                }
                else if (i < verA.length) {
                    if (+verA[i] !== 0) { return -1; }
                }
                else {
                    if (+verB[i] !== 0) { return 1; }
                }
                i++;
            }
            return 0;
          })));
        });

        this.relational = rel.sort((a, b) => (a.name > b.name) ? 1 : -1);

      });
    });
  }

  /**
   * Determines whether or not the user has permissions to edit packages.
   *
   * @func hasPackageManagement
   * @returns true if the user can edit packages; false otherwise.
   */
  hasPackageManagement(): boolean {
    return sessionStorage.getItem('permissions').indexOf('package-management') > 0;
  }

  /**
   * Toggles between showing and hiding all versions of a given package.
   *
   * @func toggleShowAll
   * @param {PackageName} pack - the package grouping to show/hide.
   */
  toggleShowAll(pack: PackageName) {
      pack.seeAll = !pack.seeAll;
  }

  /**
   * Selects a single package to view/edit.
   *
   * @func onSelect
   * @param {Package} selPackage - the package to select.
   */
  onSelect(selPackage: Package) {
      this.selectedPackage = selPackage;
  }

  /**
   * Toggles the visibility of the package creation modal.
   *
   * @func toggleAdd
   */
  toggleAdd() {
    this.showAdd = !this.showAdd;
  }

  showAddModal() {
    $(this._el.nativeElement).find('#modal-add-package').show();
    this.newPak.name = "";
  }

  hideAddModal() {
    $(this._el.nativeElement).find('#modal-add-package').hide();
  }

  /**
   * @todo I think this controls CSS, but I'm not sure.
   *
   * @func toggleListChange
   */
  toggleListChange() {
    this.changeListToggle = !this.changeListToggle;
  }

  /**
   * @todo I think this controls CSS, but I'm not sure.
   *
   * @func toggleTrayChange
   */
  toggleTrayChange() {
    this.changeTrayToggle = !this.changeTrayToggle;
  }

  /**
   * Shows and hides the detailed view of the rule modal.
   *
   * @func showPreview
   * @param {Rule} rule - the rule to show.
   */
  showPreview(rule) {
    this.ruleDetail = rule;
    $(this._el.nativeElement).find('#modal-rule-details').show();
  }

  /**
   * Strips alphabetic characters from the version number string.
   *
   * @func stripAlpha
   * @param {boolean} isVersion - true is the current field being edited is "Package version."
   */
  stripAlpha(isVersion: boolean) {
    if (isVersion) {
      this.newPak.version = this.newPak.version.replace(/[a-zA-Z]/g, '');
    }
    else{
      this.newPak.requiredNlpVersion = this.newPak.requiredNlpVersion.replace(/[a-zA-Z]/g, '');
    }
  }

  /**
   * Checks to see if the package already exists, and if not, creates the new package.
   *
   * @func onSubmit
   */
  onSubmit() {
    $('.modal-backdrop').hide();
    this.nameError = false;

    if ((this.existingPackages.filter(pack => this.newPak.name === pack).length > 0) || (this.newPak.name.trim() == "")) {
      this.nameError = true;
    }
    else {
      this._service.addPackage(this.newPak).then(() => {
        this.listChange.emit(this.newPak.name);
        $(this._el.nativeElement).find('#modal-add-package').hide();
      }).then(() => {
        this.doUpdate(this.newPak);
      })
    }
  }

  /**
   * Clears/resets the new package dialog on exit.
   *
   * @func onCancel
   */
  onCancel() {
    $('.modal-backdrop').hide();
    this.newPak = { _id: '', name: '', version: '1.0.0', state: 'Unpublished' };
    this.nameError = false;
    this.hideAddModal();
    $('#modal-rule-details').hide();
  }
 }
